var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "find",
    transform: "translate(-535 -376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    transform: "translate(535 376)",
    fill: "#fff",
    stroke: "#3e3e3e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "recruitment_solid",
    transform: "translate(539 380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M10.221,45.512a.4.4,0,1,0-.567.567l2.838,2.838a.4.4,0,1,0,.568-.568Z",
    transform: "translate(-3.314 -24.782)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M6.056,53.618l1.987-1.986-1.7-1.7L4.353,51.916a1.2,1.2,0,1,0,1.7,1.7Z",
    transform: "translate(0 -27.496)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M19.293,7.647a7.5,7.5,0,0,0-1.37.465l.332.73a6.856,6.856,0,0,1,7.651,1.388A6.815,6.815,0,1,1,17.5,9.247l-.422-.683a7.653,7.653,0,0,0-1.386,1.1,7.609,7.609,0,0,0-.779,9.86L13.7,20.731l1.7,1.7,1.209-1.209a7.623,7.623,0,0,0,2.679,1.237v4.014H32.136V4H19.293Zm11.639.366H27.32v-.8h3.612ZM21.7,5.2h9.231v.8H21.7Z",
    transform: "translate(-5.661)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M28.864,32.4a2.41,2.41,0,0,0-2.408,2.408h4.816A2.411,2.411,0,0,0,28.864,32.4Z",
    transform: "translate(-13.444 -17.003)",
    fill: "#3e3e3e",
    stroke: "#3e3e3e",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1.204,
    cy: 1.204,
    r: 1.204,
    transform: "translate(14.216 12.188)",
    fill: "#3e3e3e",
    stroke: "#3e3e3e",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.85f88f92bb4ebe51067b9e04763333a9.svg";
export { ForwardRef as ReactComponent };